import { createFileRoute } from '@tanstack/react-router';
import { RequireAuth } from '@/components/layout/RequireAuth';
import { NotificationInbox } from '@/components/notifications/inbox';

/**
 * Notification inbox (T-0109 / E10 / C20-130 — implements E09-F03 §4
 * inbox surface).
 *
 * The route renders the flat tabbed inbox per the design prototype
 * (`design_handoff_caliber_v2/prototype/screens-portfolio.js →
 * Screens.notifications`). C20-130 retired the prior critical/warning/
 * info grouped layout in favour of the flat tab-filtered list the
 * prototype ships.
 */
export const Route = createFileRoute('/notifications')({
  component: NotificationsPage,
});

function NotificationsPage() {
  return (
    <RequireAuth>
      <div className="p-card-pad">
        <NotificationInbox />
      </div>
    </RequireAuth>
  );
}
